import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Suspense } from "react";
import AppLoading from "../app-loading/app-loading";

const SummaryTableInDetailsDatatable = ({ data, type }: any) => {

    const dateBody = (rowData: any) => {
        const dt = new Date(rowData.createdDate);
        return dt.toLocaleDateString('en-GB'); // Outputs: 22/07/2025
    };

    return (
        <div className="col-12">
            <Suspense fallback={<AppLoading />}>
                <DataTable
                    value={data}
                    paginator
                    rows={10}
                    rowsPerPageOptions={[5, 10, 20, 50]}
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                >
                    <Column header="Date" body={dateBody} />
                    <Column field="quantity" header="Quantity" sortable />
                    <Column field="fromName" header={type === "Inward" ? "From" : "To"} sortable />
                    <Column field="sourceTypeName" header="Source" sortable />
                    <Column field="vendorName" header="Vendor" sortable />
                </DataTable>
            </Suspense>
        </div>
    )

}

export default SummaryTableInDetailsDatatable;
